import callApi from './personnelService';

const basePath = `/frontend/api/one-to-one/${process.env.VUE_APP_COMPANY_KEY}/order-online`;

export const getMemberData = (userId) => callApi({
  method: 'POST',
  endpoint: `${basePath}/get-member-order-online-data`,
  body: userId
});

export const getMemberCountList = () => callApi({
  endpoint: `${basePath}/get-member-order-online-count`
});

export const getActivityList = () => callApi({
  endpoint: `${basePath}/get-order-online-activity`
});
export const getOrderProducts = (input) => callApi({
  method: 'POST',
  endpoint: `${basePath}/get-order-menu-products`,
  body: input
});
export const updateOrderProducts = (updateInfo) => callApi({
  method: 'POST',
  endpoint: `${basePath}/update-order-menu-product`,
  body: updateInfo
})